'use client';

import classNames from 'classnames';
import {type ComponentProps, useEffect} from 'react';
import {useCurrentThemeVariant, useThemeStore} from '../store/themeColorsStore';

export function Theme({hasDarkMode, className, ...props}: ComponentProps<'div'> & {hasDarkMode: boolean}) {
  const variant = useCurrentThemeVariant();
  useEffect(() => {
    if (!hasDarkMode && variant === 'dark') {
      useThemeStore.setState({themeColorsVariant: 'light'});
    }
  }, [hasDarkMode, variant]);

  return <div className={classNames(hasDarkMode && variant === 'dark' && 'dark', className)} {...props} />;
}
